import { getFirstName, getLastName } from '../../../lib/copy';

import {
  PatientRow,
  PatientRowValues,
  NewPatientLeadType,
} from '../../../types/PatientManagement';
interface FormattedValidatedData {
  [key: string]: NewPatientLeadType;
}

export const formatValidatedPatientLeads = (
  validatedData: PatientRowValues,
) => {
  const formatRow = (row: PatientRow, rowIndex: number) => {
    return {
      inputId: rowIndex,
      email: row.email.trim().toLowerCase(),
      phoneNumber: row.phoneNumber?.trim().toLowerCase(),
      firstName: getFirstName(row.name.trim()),
      lastName: getLastName(row.name.trim()),
      tags:
        row.tags && row.tags.length > 0
          ? row.tags.map((tag) => {
              // Only include keys that are present; for new tags, { name } is sufficient
              const payload: Record<string, any> = { name: tag.name };
              if (tag.id) payload.id = tag.id;
              if (tag.color) payload.color = tag.color;
              if (tag.description) payload.description = tag.description;
              return payload;
            })
          : undefined,
    };
  };

  const formattedValidatedData: FormattedValidatedData = {};

  if (validatedData.patientRows?.length > 0)
    validatedData.patientRows.forEach((patientRow, index) => {
      formattedValidatedData[patientRow.email] = formatRow(patientRow, index);
    });

  return Object.values(formattedValidatedData);
};
